import * as E from 'fp-ts/Either';
import { flow, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import * as t from 'io-ts';
import * as s from '../fp-ts/string';
var toPredicate = function (f) {
    return function (u) {
        return pipe(u, f, O.isSome);
    };
};
export var withPrefix = function (prefix, codec) {
    return new t.Type("WithPrefix(".concat(codec.name, ")"), toPredicate(flow(O.fromPredicate(t.string.is), O.filter(function (str) { return pipe(str, s.startsWith(prefix)); }), O.filter(function (str) { return pipe(str, s.unprepend(prefix), codec.is); }))), function (u, c) { return pipe(codec.validate(u, c), E.map(s.prepend(prefix))); }, function (a) { return pipe(s.unprepend(prefix)(a), codec.encode); });
};
